import * as React from 'react';
import SVGIcon from '../SVGIcon';

const ExternalLinkSVG: React.FC = () => (
  <SVGIcon viewBox="0 0 14 14" width="14" height="14" fill="none">
    <path
      d="M8.25 0.125122V1.37512H11.7266L4.05078 9.0509L4.94922 9.94934L12.625 2.27356V5.75012H13.875V0.125122H8.25ZM0.125 2.62512V13.8751H11.375V5.75012L10.125 7.00012V12.6251H1.375V3.87512H7L8.25 2.62512H0.125Z"
      fill="#187A90"
    />
  </SVGIcon>
);

export default ExternalLinkSVG;
